import { G2S } from '../g2s';
import * as api from '../api';

export class DestinationService {
    list(iataCodes: string[]): Promise<api.Destination[]> {
        return new Promise<api.Destination[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/List',
                    {
                        iataCodes: iataCodes
                    })
                .then(function (response) {
                    resolve(<api.Destination[]>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    lookup(lookupText: string): Promise<api.Destination[]> {
        return new Promise<api.Destination[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/Lookup',
                    {
                        lookupText: lookupText
                    }
                )
                .then(function (response) {
                    resolve(<api.Destination[]>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    listCities(countryUniqueId: string): Promise<api.Destination[]> {
        return new Promise<api.Destination[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/ListCities',
                    {
                        countryUniqueId: countryUniqueId
                    }
                )
                .then(function (response) {
                    resolve(<api.Destination[]>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    listCitiesByAlphabet(request: { countryUniqueId?: number; firstLetterOfCity?: string }) {
        return new Promise<{ letter: string; destinations: api.Destination[] }[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/ListCitiesByAlphabet ',
                    {
                        countryUniqueId: request.countryUniqueId,
                        firstLetterOfCity: request.firstLetterOfCity
                    }
                )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    listRegions() {
        return new Promise<api.Destination[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/ListRegions',
                    {}
                )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    listCountriesByAlphabet(request: { regionUniqueId?: number; firstLetterOfCountry?: string}) {
        return new Promise<{ letter: string; destinations: api.Destination[] }[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/ListCountriesByAlphabet',
                    {
                        regionUniqueId: request.regionUniqueId,
                        firstLetterOfCountry: request.firstLetterOfCountry
                    }
                )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    listAirportsByAlphabet(request: { cityUniqueId?: number; firstLetterOfAirport?: string }) {
        return new Promise<{ letter: string; destinations: api.Destination[] }[]>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Destination/ListAirportsByAlphabet',
                    {
                        cityUniqueId: request.cityUniqueId,
                        firstLetterOfAirport: request.firstLetterOfAirport
                    }
                )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
